import { Branch, Client, Club, Node } from '@xanadu/model';
import { ClientMenu } from './client-menu';
import { MenuBuilder } from './menu-builder';
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class ClientMenuBuilder extends MenuBuilder {

    public Build(node: Node, clipboard: Node): ClientMenu {
        const menu = new ClientMenu();

        if (node instanceof Club) {
            this.forClub(menu, node);
        } else if (node instanceof Client) {
            this.forClient(menu, node);
        }

        this.forEdit(menu, node, clipboard);

        return menu;
    }

    private forClub(menu: ClientMenu, node: Node): void {
        if (node.isNew) {
            return;
        }

        menu.club = true;
        menu.client = true;
    }

    private forClient(menu: ClientMenu, node: Node): void {
    }

    private forEdit(menu: ClientMenu, node: Node, clipboard: Node): void {
        menu.delete = !!node.parentId && (!(node instanceof Branch) || !node.nodes?.length && !node.branches?.length);
        menu.cut = !!node.parentId;
        menu.copy = !!node.parentId && !(node instanceof Club);
        menu.paste = clipboard && !clipboard.childOf(node) && clipboard.fit(node as Branch) && !node.isNew;
    }
}
